import React from 'react'
import styled from "styled-components"
import media from "styled-media-query"
import map from "../../image/map.jpg"

const Access = () => {

   return (
      <AccessStyles id="access" map={map}>
         <div className="title-box">
            <h2>アクセス</h2>
            <div className="deco"></div>
         </div>
         <div className="access-box">
            <div className="address">
               <div className="texts">
                  <h3>天心塾</h3>
                  <p className="located">
                     〒208-0013<br/>
                     東京都武蔵村山市大南４丁目１８－１
                  </p>
                  <p className="walk">
                     ※西武拝島線「玉川上水駅」より徒歩15分<br/>
                     ※東京都立上水高等学校より徒歩5分
                  </p>
                  <a 
                     href="https://www.google.com/maps/place/%E5%A4%A9%E5%BF%83%E5%A1%BE/@35.7342414,139.408186,15z/data=!4m5!3m4!1s0x0:0x711509d9ba99cd8f!8m2!3d35.7342414!4d139.408186"
                     target="_blank"
                     rel="noopener noreferrer"
                  >
                     ⇒Google Mapで確認する
                  </a>
               </div>
            </div>
            <div className="map">
            </div>
         </div>
      </AccessStyles>
   )
}

const AccessStyles = styled.section`
   width: 100%;
   margin-top: 1px;
   .access-box {
      display: flex;
      width: 100%;
      height: 390px;
      margin-top: 1px;
      ${media.lessThan("960px")`
         height: 600px;
         flex-direction: column-reverse;
      `}
      .address {
         width: 43%;
         height: 100%;
         background-color: #FF8787;
         display: flex;
         justify-content: center;
         align-items: center;
         color: #fff;
         ${media.lessThan("960px")`
            width: 100%;
            height: 50%;
         `}
         .texts {
            h3 {
               font-size: 3.2rem;
               text-align: center;
               ${media.lessThan("600px")`
                  font-size: 2rem;
               `}
            }
            .located, .walk {
               margin-top: 24px;
               font-size: 2rem;
               line-height: 3.4rem;
               ${media.lessThan("600px")`
                  margin-top: 8px;
                  font-size: 1.5rem;
                  line-height: 2rem;
               `}
            }
            a {
               display: block;
               margin-top: 10px;
               color: #cfcfcf;
               font-size: 1.6rem;
               text-decoration: underline;
               &:hover {
                  color: #fff;
               }
            }
         }
      }
      .map {
         width: 57%;
         height: 100%;
         background-image: url(${({map}) => map});
         background-size: cover;
         background-position: 50% 50%;
         overflow: hidden;
         text-align: center;
         ${media.lessThan("960px")`
            width: 100%;
            height: 60%;
         `} 
      }
   }
`

export default Access